import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6dc8b460"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "recurringEventsContainer" };
const _hoisted_2 = { class: "text-xs text-gray-700 font-medium border-gray-300 border-[1px] px-[12px] py-[8px] rounded-xl mt-1 w-fit ml-[5px]" };
const _hoisted_3 = { class: "text-sm text-gray-700 font-medium mt-4 pl-[5px]" };
const _hoisted_4 = { class: "text-sm text-gray-500 font-medium mt-1 pl-[5px]" };
const _hoisted_5 = { class: "mt-4 text-sm" };
const _hoisted_6 = { class: "eventDate" };
const _hoisted_7 = { class: "eventTime" };
const _hoisted_8 = {
    key: 0,
    class: "border-[0.5px] border-t-[1px] border-gray-200 mt-[5px]"
};
import { UIModal, UIModalHeader } from '@gohighlevel/ghl-ui';
import { appointmentWizardState, recurringSlots, selectedCalendar, toggleRecurringModal, } from './appointmentWizardState';
export default /*#__PURE__*/ _defineComponent({
    __name: 'RecurringEventsModal',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                show: _unref(appointmentWizardState).showRecurringModal,
                width: 460
            }, {
                header: _withCtx(() => [
                    _createVNode(_unref(UIModalHeader), {
                        title: _unref(appointmentWizardState).appointmentTitle ||
                            _ctx.$t('appointmentModal.recurring_appointments'),
                        onClose: _unref(toggleRecurringModal),
                        id: "modal-header"
                    }, null, 8, ["title", "onClose"])
                ]),
                default: _withCtx(() => {
                    var _a;
                    return [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, _toDisplayString((_a = _unref(selectedCalendar)) === null || _a === void 0 ? void 0 : _a.name), 1),
                            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('appointmentModal.recurring_appointments')), 1),
                            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('appointmentModal.repeats')) + " " + _toDisplayString(_unref(appointmentWizardState).rruleText), 1),
                            _createElementVNode("div", _hoisted_5, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recurringSlots), (slot, n) => {
                                    return (_openBlock(), _createElementBlock("div", { key: n }, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["singleEventContainer", { disabledSingleEventContainer: slot.isUnavailable }])
                                        }, [
                                            _createElementVNode("div", _hoisted_6, _toDisplayString(slot.statusText), 1),
                                            _createElementVNode("div", _hoisted_7, _toDisplayString(slot.time), 1),
                                            (n != _unref(recurringSlots).length - 1)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                                                : _createCommentVNode("", true)
                                        ], 2)
                                    ]));
                                }), 128))
                            ])
                        ])
                    ];
                }),
                _: 1
            }, 8, ["show"]));
        };
    }
});
